import { useBudgetScope } from "./useBudgetScope";
import { useFetchBudgetVersions } from "./useFetchBudgetVersions";

/**
 * Budget versions for a brand selection, resolved against the tenant's budget
 * scope: a tenant-scoped budget belongs to no brand, so the selection is
 * ignored and the tenant's own versions are fetched; a brand-scoped one waits
 * for a brand to be picked.
 *
 * Every budget-version surface (page selector, summary source, copy source,
 * create modals) goes through here so the brand requirement is relaxed in one
 * place rather than per call site.
 */
export function useScopedBudgetVersions(
  brand: string | undefined,
  enabled: boolean = true
) {
  const tenantScoped = useBudgetScope() === "tenant";
  return useFetchBudgetVersions(
    tenantScoped ? null : (brand ?? ""),
    enabled && (tenantScoped || !!brand)
  );
}
